import Cookies from 'js-cookie';
import { Session } from '../model/Session';
import { User } from '../model/User';

// The token is read by JS (it's sent as X-Session-Token), so the cookie can't be HttpOnly.
// Secure keeps it off plain http (localhost dev aside), Strict keeps it out of cross-site requests.
export const SESSION_COOKIE_ATTRIBUTES: Cookies.CookieAttributes = {
  expires: 60,
  secure: window.location.protocol === 'https:',
  sameSite: 'strict',
};

export const readSession = (): Session | null => {
  try {
    return JSON.parse(Cookies.get('session') ?? 'null');
  } catch {
    return null;
  }
};

/** Keeps the saved session's user in step with the account, e.g. its language for the next reload */
export const updateSessionUser = (changes: Partial<User>) => {
  const session = readSession();
  if (!session) return;
  Cookies.set('session', JSON.stringify({ ...session, user: { ...session.user, ...changes } }), SESSION_COOKIE_ATTRIBUTES);
};
